<template>
  <div class="flex flex-col w-full pb-4">
    <p class="text-[11.5px] text-gray-500 leading-relaxed mb-3.5">
      בחרו סניף — ייפתח לו לוח שעות עם ברירת מחדל (א׳–ה׳, 09:00–18:00) שתוכלו לערוך.
    </p>
    <div class="flex flex-col gap-2">
      <button
        v-for="b in remaining"
        :key="b.id"
        type="button"
        class="flex items-center gap-2.5 p-3 rounded-xl border border-gray-200 active:bg-gray-50"
        @click="emit('pick', b.id)"
      >
        <span class="w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center flex-none">
          <i class="pi pi-map-marker text-sm" />
        </span>
        <div class="flex-1 min-w-0 text-right">
          <div class="text-[13.5px] font-medium truncate">{{ b.name }}</div>
          <div v-if="b.address" class="text-[11px] text-gray-500 truncate">{{ b.address }}</div>
        </div>
        <i class="pi pi-plus text-primary text-sm flex-none" />
      </button>
      <div v-if="!remaining.length" class="text-center text-[12.5px] text-gray-400 py-3">כל הסניפים כבר משויכים</div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ remaining: Array<{ id: string; name: string; address?: string }> }>();
const emit = defineEmits<{ pick: [id: string]; close: [] }>();
</script>
